import { motion } from "framer-motion";

export default function Founder() {
  return (
    <section
      id="founder"
      className="relative py-24 md:py-32 border-y border-white/5 bg-ink-50/40"
      data-testid="founder-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl"
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
            / 06 — Why Devzcorner
          </div>
          <h2
            className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            data-testid="founder-heading"
          >
            Integrated end-to-end.
            <br />
            <span className="text-zinc-500">
              Built as one system.
            </span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed max-w-2xl text-base md:text-lg">
            Most builds fail at discipline boundaries. Devzcorner is structured
            to remove those boundaries — product strategy, interface, backend,
            AI, firmware, and enclosure development aligned within one delivery
            system. That means faster decisions, cleaner execution, and full
            accountability from first scope to final ship.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
